export const CALLER_ID_DRAWER_INDEX = 1000;
export const QUICK_BOOKING_INDEX = CALLER_ID_DRAWER_INDEX + 2;
// Prompts opened on top of a booking modal (same-day alert, then PIN) must stack above Quick Booking.
export const SAME_DAY_BOOKING_ALERT_INDEX = QUICK_BOOKING_INDEX + 10;
export const PIN_VERIFY_INDEX = QUICK_BOOKING_INDEX + 20;
export const STAFF_AVAILABLE_PICKER_INDEX = 9999;
export const TIME_PICKER_INDEX = STAFF_AVAILABLE_PICKER_INDEX + 1;
export const CUSTOMER_DETAIL_MODAL_INDEX = STAFF_AVAILABLE_PICKER_INDEX + 2;